import React from 'react';
import { connect } from 'react-redux';
import ShortcutButton from '../shortcut-button/ShortcutButton';
import { goToStep, completeWizard, goToFollowUpCallStep, goToBookMeetingStep } from './logActivityReducer';

@connect(
    state => ({}),
    { goToStep, completeWizard, goToFollowUpCallStep, goToBookMeetingStep }
)
export default class BookFollowUpOptionsStep extends React.Component {
    submitAndIgnore() {
        this.props.completeWizard();
    }
    bookPhoneCall() {
        this.props.goToFollowUpCallStep();
    }
    bookMeeting() {        
        this.props.goToBookMeetingStep();
    }
    render() {
        return(
            <div className="wizard-step-wrapper">
                <h1>Book a Follow Up?</h1>
                <div className="actions-row" style={{paddingTop: 10}}>
                    <ShortcutButton shortcut="i" type="primary" onClick={this.submitAndIgnore.bind(this)} >
                        Ignore
                    </ShortcutButton>

                    <ShortcutButton shortcut="p" type="success" onClick={this.bookPhoneCall.bind(this)}>
                        Phone Call
                    </ShortcutButton>

                    <ShortcutButton shortcut="m" type="success" onClick={this.bookMeeting.bind(this)}>
                        Meeting
                    </ShortcutButton>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/BookFollowUpOptionsStep.js